import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import { OrderCashInEdit, OrderCashOutEdit, OrderCashInCopy, OrderCashOutCopy } from './CashInOut'
import { MemorialOrderEdit, MemorialOrderCopy, MemorialOrderAddFormModal } from './MemorialOrderAdd'
import OrderAddDropdown from './OrderAddDropdown'
import {
  ConvertOnAccountFormModal,
  OrderConvertOnAccountEdit,
  OrderConvertOnAccountCopy,
  ConvertOnCashboxFormModal,
  OrderConvertInCashEdit,
  OrderConvertInCashCopy,
} from './ConvertOnAccountInCash'

const MEMORIAL_ORDER_ADD_MODAL = 'MemorialOrderAddInNavigation'

export const createMemorialOrderAddNavigationItem = createNavigationConfig((translateFn: (key: string) => string) => ({
  icon: 'entries_memorial',
  text: translateFn('mnu_acc_order_add'),
  identity: MEMORIAL_ORDER_ADD_MODAL,
  permission: 'ACC_ENTRIES_ADD_MEMORDER',
  component: MemorialOrderAddFormModal,
}))

const ORDER_CASH_IN_ADD_MODAL = 'OrderCashInAddInNavigation'
const OrderCashInAddModal = Loadable(() => import('./CashInOut/OrderCashInAdd'))

export const createOrderCashInAddNavigationItem = createNavigationConfig((translateFn: (key: string) => string) => ({
  icon: 'entries_cashin',
  text: translateFn('mnu_acc_cashin_add'),
  identity: ORDER_CASH_IN_ADD_MODAL,
  permission: 'ACC_ENTRIES_ADD_CASHIN',
  component: OrderCashInAddModal,
}))

const ORDER_CASH_OUT_ADD_MODAL = 'OrderCashOutAddInNavigation'
const OrderCashOutAddModal = Loadable(() => import('./CashInOut/OrderCashOutAdd'))

export const createOrderCashOutAddNavigationItem = createNavigationConfig((translateFn: (key: string) => string) => ({
  icon: 'entries_cashout',
  text: translateFn('mnu_acc_cashout_add'),
  identity: ORDER_CASH_OUT_ADD_MODAL,
  permission: 'ACC_ENTRIES_ADD_CASHOUT',
  component: OrderCashOutAddModal,
}))

const ORDER_CONVERT_ON_ACCOUNT_MODAL = 'OrderConvertOnAccountInNavigation'

export const createConvertOnAccountNavigationItem = createNavigationConfig((translateFn: (key: string) => string) => ({
  icon: 'entries_conv',
  text: translateFn('mnu_acc_conv_add'),
  identity: ORDER_CONVERT_ON_ACCOUNT_MODAL,
  permission: 'ACC_ENTRIES_ADD_CONV',
  component: ConvertOnAccountFormModal,
}))

const ORDER_CONVERT_ON_CASHBOX_MODAL = 'OrderConvertOnCashboxInNavigation'

export const createConvertOnCashboxNavigationItem = createNavigationConfig((translateFn: (key: string) => string) => ({
  icon: 'entries_convcash',
  text: translateFn('mnu_acc_conv_cash_add'),
  identity: ORDER_CONVERT_ON_CASHBOX_MODAL,
  permission: 'ACC_ENTRIES_ADD_CONV_CASH',
  component: ConvertOnCashboxFormModal,
}))

export {
  MemorialOrderEdit,
  MemorialOrderCopy,
  OrderCashInEdit,
  OrderCashOutEdit,
  OrderCashInCopy,
  OrderCashOutCopy,
  OrderAddDropdown,
  OrderConvertOnAccountEdit,
  OrderConvertOnAccountCopy,
  OrderConvertInCashEdit,
  OrderConvertInCashCopy,
}
